module.exports = __webpack_public_path__ + "assets/icon_cancel.61f545b2.svg";